/**
 * 空状态提示组件
 *
 * 显示空状态的提示信息和图标
 */

import React from 'react';

interface EmptyStateProps {
  /** 提示消息 */
  message: string;
  /** 图标 */
  icon?: React.ReactNode;
  /** 自定义类名 */
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  icon,
  className = '',
}) => {
  const defaultIcon = (
    <svg className="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
      />
    </svg>
  );

  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      {icon || defaultIcon}
      <p className="text-gray-500 text-center">{message}</p>
    </div>
  );
};

export default EmptyState;